import { FC } from "react";

import { Text } from "@/components/ui";

/* ── Types ─────────────────────────────────────── */

interface RichTextProps {
  /** Class for the bold spans. */
  boldClassName?: string;
  boldStyle?: { color?: string };
  className?: string;
  style?: { color?: string };
  /** Copy where `**text**` marks terms to highlight. */
  text: string;
}

/* ── Component ─────────────────────────────────── */

/** Paragraph with `**bold**` markers rendered as emphasised spans. */
const RichText: FC<RichTextProps> = ({
  boldClassName = "font-semibold",
  boldStyle,
  className,
  style,
  text,
}) => (
  <Text className={className} style={style}>
    {segments(text).map((segment, i) =>
      segment.bold ? (
        <Text
          className={`${className ?? ""} ${boldClassName}`}
          key={i}
          style={boldStyle ?? style}
        >
          {segment.text}
        </Text>
      ) : (
        segment.text
      )
    )}
  </Text>
);

/* ── Helpers ───────────────────────────────────── */

const segments = (text: string): { bold: boolean; text: string }[] =>
  text
    .split("**")
    .map((part, i) => ({ bold: i % 2 === 1, text: part }))
    .filter((s) => s.text.length > 0);

export default RichText;
